import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

export const GetHSNChapterandCreateHSNChapter = async(method,data)=>{
    return axios({
        method:method,                                               // This is used to get and post chapter data from API
        url:`${BASE_URL}LADProducts/hsn/chapter/`,
        data:data
    })
}
export const GetHSNHeadingandCreateHSNHeading = async (method, data) => {
    return axios({
        method: method,                                               // This is used to get and post Heading data from API
        url: `${BASE_URL}LADProducts/hsn/heading/`,
        data: data
    });
};
export const GetHSNSubheadingandCreateHSNSubheading = async (method, data) => {
    return axios({
        method: method,                                                // This is used to get and post Sub Heading data from API
        url: `${BASE_URL}LADProducts/hsn/subheading/`,
        data: data
    });
};
export const GetHSNClassificationandCreateHSNClassification = async (method, data) => {
    return axios({
        method: method,                                                 // This is used to get and post classification data from API
        url: `${BASE_URL}LADProducts/hsn/classifications/`,
        data: data
    });
};

export const UpdateHSNChapterandDeleteHSNChapter = async (method, id, data) => {
    return axios({
        method: method,                                                 // This is used to put and delete chapter data from API
        url: `${BASE_URL}LADProducts/hsn/chapter/${id}/`,
        data: data
    });
}
export const UpdateHSNHeadingandDeleteHSNHeading = async (method, id, data) => {
    return axios({
        method: method,                                                  // This is used to put and delete Heading data from API
        url: `${BASE_URL}LADProducts/hsn/heading/${id}/`,
        data: data
    });
};
export const UpdateHSNSubheadingandDeleteHSNSubheading = async (method,id, data) => {
    return axios({
        method: method,                                                  // This is used to put and delete Sub Heading data from API
        url: `${BASE_URL}LADProducts/hsn/subheading/${id}/`,
        data: data
    });
};

export const UpdateHSNClassificationandDeleteHSNClassification = async (method,id, data) => {
    return axios({
        method: method,                                                   // This is used to put and delete classification data from API
        url: `${BASE_URL}LADProducts/hsn/classifications/${id}/`,
        data: data
    });
};

export const HSNSearch = async (method, searchTerm) => {
    try {
        const url = `${BASE_URL}/LADProducts/hns-search/?search=${encodeURIComponent(searchTerm)}`;

        const response = await axios({
            method: method,                                                // This is used to get search data from API
            url: url,
            maxRedirects: 0,  // Prevent automatic redirects
        });
        return response;
    } catch (error) {
        throw error;
    }
};


export const ImportLinkUnit = async(method,data)=>{
    return axios({
        method:method,                                         // This is used to get and post Sub category data from API
        url:`${BASE_URL}LADProducts/import-categories/`,
        data:data
    })
}